import { isFeatureOn } from './utils/isFeatureOn';
import { Environment } from 'src/types';

// Feature toggle names
export enum Features {
  TOGGLE_EXAMPLE_FEATURE = 'feature-a',
}

export type ToggleItem = {
  [key in Features]?: boolean;
};

type FeatureToggles = {
  [key in Environment]: ToggleItem;
};

// Feature Toggles for each environment
const FEATURE_TOGGLES: FeatureToggles = {
  [Environment.DEV]: {},
  [Environment.STAGING]: {},
  [Environment.PROD]: {},
};

export const setFeatureToggles = (environment: Environment) =>
  FEATURE_TOGGLES[environment];

export { isFeatureOn };
